<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<fab-loading-spinner [hidden]="(!showSpinner)" color="primary"></fab-loading-spinner>
<div id="header-container">
  <h3 id="header-text">Create Vehicle Forecast Template</h3>
  <div>
    <button color="primary" class="confirm-button"
            id="confirm-button"
            [disabled]="!(this.selectedStartYear && this.selectedEndYear)"
            (click)="onExportTemplate()"
            mat-raised-button>
      Export Template
    </button>
    <button color="primary" class="confirm-button"
            id="quick-edit-button"
            [disabled]="!(this.selectedStartYear && this.selectedEndYear)"
            (click)="openQuickEditPopUp()"
            mat-raised-button>
      Online Edit
    </button>
  </div>
</div>
<div>
  <mat-form-field subscriptSizing="dynamic" class="default-margin">
    <mat-label>Region</mat-label>
    <fab-multiselect
      name="regionFilter"
      [(ngModel)]="regionFilter.selectedOptions"
      (ngModelChange)="onFilterChange(REGION)"
      [options]="regionFilter.options">
    </fab-multiselect>
  </mat-form-field>

  <mat-form-field subscriptSizing="dynamic" class="default-margin">
    <mat-label class="asterisk--before">By Subregion or Mkt Area</mat-label>
    <mat-select
      (selectionChange)="selectedByType === 'By Subregion' ? onFilterChange(SUBREGION) : onFilterChange(MKTAREA)"
      [(ngModel)]="selectedByType" id="byTypeFilter">
      <mat-option value="By Subregion">By Subregion</mat-option>
      <mat-option value="By Mkt Area">By Mkt Area</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field subscriptSizing="dynamic" *ngIf="selectedByType === 'By Subregion'" subscriptSizing="dynamic"
                  class="default-margin">
    <mat-label>Subregion</mat-label>
    <fab-multiselect
      id="subregionFilter"
      name="subregionFilter"
      [(ngModel)]="subregionFilter.selectedOptions"
      (ngModelChange)="onFilterChange(SUBREGION)"
      [options]="subregionFilter.options">
    </fab-multiselect>
  </mat-form-field>

  <mat-form-field subscriptSizing="dynamic" *ngIf="selectedByType === 'By Mkt Area'" class="default-margin">
    <mat-label class="asterisk--before">Market Area</mat-label>
    <mat-select (selectionChange)="onFilterChange(MKTAREA)" [(ngModel)]="selectedMktArea" id="mktAreaFilter">
      <mat-option *ngFor="let name of mktAreaFilterOptions" [value]="name">
        {{name}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field subscriptSizing="dynamic" class="default-margin">
    <mat-label>Planning Market</mat-label>
    <fab-multiselect
      id="plngMktFilter"
      name="plngMktFilter"
      [(ngModel)]="plngMktFilter.selectedOptions"
      (ngModelChange)="onFilterChange(PLNGMKT)"
      [options]="plngMktFilter.options">
    </fab-multiselect>
  </mat-form-field>

  <mat-form-field subscriptSizing="dynamic" class="default-margin">
    <mat-label class="asterisk--before">Segment Level</mat-label>
    <mat-select (selectionChange)="onFilterChange(PLNGMKT)" [(ngModel)]="selectedSgmntLvl" id="sgmntLvlFilter">
      <mat-option value="Total Vehicle">Total Vehicle</mat-option>
      <mat-option value="Global Segment">Global Segment</mat-option>
      <mat-option value="Propulsion Segment">Propulsion Segment</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field subscriptSizing="dynamic" class="default-margin">
    <mat-label>Segment</mat-label>
    <fab-multiselect
      id="sgmntFilter"
      name="sgmntFilter"
      [(ngModel)]="segmentFilter.selectedOptions"
      (ngModelChange)="onFilterChange(SGMNT)"
      [options]="segmentFilter.options">
    </fab-multiselect>
  </mat-form-field>

  <mat-form-field subscriptSizing="dynamic" class="default-margin">
    <mat-label>Market Division</mat-label>
    <fab-multiselect
      id="mktDivFilter"
      name="mktDivFilter"
      [(ngModel)]="mktDivFilter.selectedOptions"
      (ngModelChange)="onFilterChange(MKTDIV)"
      [options]="mktDivFilter.options">
    </fab-multiselect>
  </mat-form-field>

  <mat-form-field subscriptSizing="dynamic" class="default-margin">
    <mat-label>Brand Family</mat-label>
    <fab-multiselect
      id="brandfamFilter"
      name="brandfamFilter"
      [(ngModel)]="brandfamFilter.selectedOptions"
      (ngModelChange)="onFilterChange(BRANDFAM)"
      [options]="brandfamFilter.options">
    </fab-multiselect>
  </mat-form-field>

  <mat-form-field subscriptSizing="dynamic" class="default-margin">
    <mat-label>Body Style</mat-label>
    <fab-multiselect
      id="bodyStyleFilter"
      name="bodyStyleFilter"
      [(ngModel)]="bodyStyleFilter.selectedOptions"
      (ngModelChange)="onFilterChange(BODYSTYLE)"
      [options]="bodyStyleFilter.options">
    </fab-multiselect>
  </mat-form-field>

  <mat-form-field subscriptSizing="dynamic" class="default-margin">
    <mat-label>Program Code</mat-label>
    <fab-multiselect
      id="prgmCodeFilter"
      name="prgmCodeFilter"
      [(ngModel)]="prgmCodeFilter.selectedOptions"
      (ngModelChange)="onFilterChange(PRGMCODE)"
      [options]="prgmCodeFilter.options">
    </fab-multiselect>
  </mat-form-field>

  <mat-form-field subscriptSizing="dynamic" class="default-margin">
    <mat-label>Type of Sale</mat-label>
    <fab-multiselect
      id="tosFilter"
      name="tosFilter"
      [(ngModel)]="tosFilter.selectedOptions"
      [options]="tosFilter.options">
    </fab-multiselect>
  </mat-form-field>

  <mat-form-field subscriptSizing="dynamic" class="default-margin">
    <mat-label class="asterisk--before">Start Year</mat-label>
    <mat-select [(ngModel)]="selectedStartYear" id="startYear">
      <mat-option *ngFor="let year of scenarioYearRange" [value]="year">{{year}}</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field subscriptSizing="dynamic" class="default-margin">
    <mat-label class="asterisk--before">End Year</mat-label>
    <mat-select [(ngModel)]="selectedEndYear" id="endYear">
      <mat-option *ngFor="let year of scenarioYearRange" [value]="year">{{year}}</mat-option>
    </mat-select>
  </mat-form-field>
  <div class="d-flex gap-16">
    <mat-radio-group [(ngModel)]="shadeByPortfolio" class="d-flex flex-column"
                     *ngIf="stateService.selectedScenario?.fcorg === GMTVP">
      <mat-radio-button [value]="true">Shade Years By Portfolio</mat-radio-button>
      <mat-radio-button [value]="false">Shade Years By Scenario</mat-radio-button>
    </mat-radio-group>
    <mat-divider [vertical]="true" *ngIf="stateService.selectedScenario?.fcorg === GMTVP"></mat-divider>
    <mat-checkbox [(ngModel)]="includeTotals"
                  [disabled]="stateService.selectedScenario?.fcorg === GMTVP">
      Planning Market Workbooks w/Industry and GM Share - Must Select Planning Markets
      <mat-icon class="icon material-icons-outlined"
                fontIcon="info"
                [matTooltip]="toolTip"></mat-icon>
    </mat-checkbox>
  </div>
</div>
